import { render, staticRenderFns } from "./NavigationCard.vue?vue&type=template&id=09070268&scoped=true"
import script from "./NavigationCard.js?vue&type=script&lang=js&external"
export * from "./NavigationCard.js?vue&type=script&lang=js&external"
import style0 from "./NavigationCard.scss?vue&type=style&index=0&id=09070268&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09070268",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotImage: require('/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Atoms/Image/Image.vue').default})
